import { getLocale } from '@/utils/locale';

export const getCurrentLocaleData = (localeString?: string) => {
    const locale = getLocale(localeString);
    let language = locale.language.name.en;
    const country = locale.country.name.en;

    if (language === 'Spanish') {
        // internal systems are expecting 'Spanish; Castilian' instead of 'Spanish'
        language = 'Spanish; Castilian';
    }

    const languageAttribute = `language|${language}`;
    const countryAttribute = `country|${country}`;

    return {
        language,
        country,
        languageAttribute,
        countryAttribute,
    };
};
